<template>
  <div>
    <!-- <div class="header_top">
      <div class="header_top_cen">
        <div class="header_list">
          <div class="header-list-link manage_join" v-if="info">
            <a href="javascript:void(0);" rel="nofollow" @click="ttt">退出</a>
          </div>

          <div class="log_mem mem_r2">
            <span>|</span>
            <a v-if="!info" id="a_top_login" href="javascript:void(0)" @click="doLogin">您好，请登录</a>
            <a
              v-else
              id="a_top_login"
              href="javascript:void(0)"
              @click="$router.push({ name: 'centerHomeIndex' })"
            >您好，{{info.name||info.mobile}}</a>
          </div>
        </div>
      </div>
    </div> -->

    <div id="app-head">
      <div class="logo-box">
        <router-link to="/">
          <img src="../../assets/images/logo.png" alt />
        </router-link>
      </div>
      <div class="head-box">
        <div class="nav-box" v-if="searchShow">
          <ul>
            <li
              v-for="(item, index) in navList"
              :key="index"
              :class="{ active: searchStatus == item.id }"
            >
              <router-link :to="{ name: item.url, query: item.params }">{{
                item.title || item.fulltitle
              }}</router-link>
            </li>
          </ul>
        </div>
        <!--div class="search-box" v-else>
        <i v-show="searchText!=''">×</i>
        <input type="text" placeholder="请输入想搜索的内容" v-model="searchText">
        <router-link
          :to="{name:'search',params:{texe:searchText,status:false}}"
          class="iconfont"
        >&#xe672;</router-link>
      </div>
        <span class="iconfont" v-show="searchShow" @click="getSearch">&#xe672;</span-->
      </div>
      <div class="btn-box">
        <span>
          <a
            v-if="!info"
            id="a_top_login"
            href="javascript:void(0)"
            @click="doLogin"
            >登录</a
          >
          <router-link v-else :to="{ name: 'centerHomeIndex' }"
            >个人中心</router-link
          >
        </span>
        <p v-if="info">
          <a href="javascript:void(0);" rel="nofollow" @click="ttt">退出登录</a>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  props: ["searchStatus"],
  data() {
    return {
      info: null,
      navList: [
        {
          id: 0,
          title: "首页",
          url: "home",
        },
      ],
      liStyle: 1,
      searchShow: true,
      searchText: "",
    };
  },
  methods: {
    ...mapMutations(["setUserInfo"]),
    ttt() {
      let data = {
        user: null,
        token: {
          access_token: null,
        },
      };
      this.setUserInfo(data);
      window.location.reload();
    },
    getStyle(id) {
      this.liStyle = id;
      sessionStorage.setItem("index", id);
      this.$emit("getId", id);
      console.log("33333", this.liStyle);
    },
    getSearch() {
      this.searchShow = false;
    },
  },
  created() {
    // console.log(123456, this.searchStatus);

    this.info = this.$store.state.user_info;
    let params = {
      pid: 0,
    };
    this.$db.post(this.$url.website.channel.list, params).then((resp) => {
      var newsNav = this.navList.concat(resp.data);
      newsNav.forEach((element) => {
        switch (element.model) {
          case "url": //外链
            break;
          case "news":
            if (element.type == "list") {
              element.url = "news";
              element.params = {
                cate_id: element.cate_id,
                moduleId: element.id,
              };
            } else {
              element.url = "newsInfo";
              element.params = {
                id: element.value_id,
              };
            }
            break;
          case "project":
            if (element.type == "all") {
              element.url = "projects";
              element.params = {
                moduleId: element.id,
              };
            } else {
              element.url = "projectInfo";
            }
            break;
          case "activity":
            if (element.type == "all") {
              element.url = "activitys";
              element.params = {
                moduleId: element.id,
              };
            } else {
              element.url = "activityInfo";
            }
            break;
          case "about":
            console.log(element, "el");
            element.url = "aboutInfo";
            element.params = {
              moduleId: element.id,
              id: element.value_id,
            };
            break;
          default:
            element.url = "home";
            break;
        }
        this.navList = newsNav;
      });
    });
  },
};
</script>

<style lang="scss" scoped>
#app-head {
  // width: 100%;
  height: 95px;
  background-color: #ffffff;
  padding: 0 53px;
  position: relative;
  overflow: hidden;
  // margin-bottom: 1px;
}
.logo-box {
  width: 87px;
  height: 76px;
  position: absolute;
  top: 10px;
  left: 53px;
  > a {
    display: block;
    > img {
      width: 100%;
      height: 100%;
    }
  }
}
.btn-box {
  height: 36px;
  position: absolute;
  top: 50%;
  right: 30px;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  text-align: center;
  line-height: 36px;
  font-size: 14px;
  > p {
    > a {
      display: block;
      width: 80px;
      height: 36px;
      margin-left: 6px;
      background-color: #f8b92b;
      color: #fff;
      border-radius: 4px;
    }
  }
  > span {
    > a {
      display: block;
      width: 80px;
      height: 36px;
      background-color: #e83a16;
      color: #fff;
      line-height: 36px;
      border-radius: 4px;
    }
  }
}
.head-box {
  max-width: 1300px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  position: relative;
  .nav-box {
    height: 100%;
    padding-left: 90px;
    > ul {
      display: flex;
      > li {
        height: 92px;
        list-style: none;
        &.active {
          border-bottom: 3px solid #e83a16;
          > a {
            color: #e83a16;
          }
        }
        > a {
          display: block;
          height: 100%;
          line-height: 92px;
          font-size: 16px;
          color: #333333;
          padding: 0 20px;
        }
      }
    }
  }
  .search-box {
    width: 440px;
    height: 50px;
    background-color: #ffffff;
    border-radius: 3px;
    border: solid 1px #dddddd;
    margin: 22px auto;
    padding: 0 38px;
    position: relative;
    > i {
      font-style: normal;
      color: #333;
      font-size: 30px;
      font-weight: 200;
      position: absolute;
      left: 13px;
      top: 50%;
      transform: translateY(-50%);
    }
    > a {
      color: #333;
      font-size: 16px;
      position: absolute;
      top: 50%;
      right: 16px;
      transform: translateY(-50%);
    }
    > input {
      margin: 0;
      padding: 0;
      outline: none;
      border: none;
      width: 100%;
      line-height: 50px;
      font-size: 16px;
      color: #333;
    }
  }
  > span {
    width: 19px;
    height: 19px;
    color: #333;
    font-size: 16px;
    position: absolute;
    top: 50%;
    right: 280px;
    transform: translateY(-50%);
    cursor: pointer;
  }
}

.header_top {
  width: 100%;
  height: 36px;
  background: #f6f6f6;
}

.header_top .header_top_cen {
  width: 1190px;
  height: 100%;
  margin: 0 auto;
}
.header_list {
  height: 36px;
  line-height: 36px;
  margin: 0 auto;
}

.header-list-link.manage_post,
.header-list-link.manage_join,
.header-list-link.customer_service {
  border-left: 1px solid #f6f6f6;
  border-right: 1px solid #f6f6f6;
  box-sizing: border-box;
  position: relative;
}

.header_list .header-list-link {
  float: right;
}

// .header-list-link.manage_post > a,
// .header-list-link.manage_join > a,
// .header-list-link.customer_service > a {
//   padding-right: 20px;
//   background: url(https://img-qn.hdb.com/static_v4/images/other/mana_jiao_down_2.png)
//     no-repeat right center;
// }

.header_list .header-list-link > a {
  font-size: 12px;
  color: #999;
  display: inline-block;
  margin: 0 20px;
  float: left;
}
.header_list .log_mem {
  margin: 0 12px;
}

.mem_r2 {
  height: 36px;
  float: right;
}
.header_list span {
  font-size: 12px;
  color: #ccc;
  display: inline-block;
  float: right;
}

.mem_r2 a#a_top_register {
  margin: 0 12px;
}

.mem_r2 a {
  display: inline-block;
  float: right;
  line-height: 36px;
  font-size: 12px;
  color: #999;
}
.mem_r2 a#a_top_login {
  margin: 0 12px;
  color: #0099e9;
}
</style>



// WEBPACK FOOTER //
// src/view/Public/header.vue